import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import useApiGet from '../hooks/getData';
import toast from 'react-hot-toast';
import axios from 'axios';
import { useSelector } from 'react-redux';
import Searchbar from '../../components/Search';
import NoData from '../../assets/NoData.png';

function FrameList() {
  const token = Cookies.get("Snapta_Admin_Token");
  const { getData } = useApiGet();
  const isSidebarOpen = useSelector((state) => state.sidebar.isOpen);

  const [frames, setFrames] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [saving, setSaving] = useState(false);

  const [name, setName] = useState("");
  const [coins, setCoins] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [imageFile, setImageFile] = useState(null);

  const fetchFrames = async () => {
    setLoading(true);
    try {
      const res = await getData('/admin_frames_list');
      setFrames(res?.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchFrames(); }, []);

  const resetForm = () => {
    setName("");
    setCoins("");
    setIsActive(true);
    setImageFile(null);
    setEditingId(null);
  };

  const openAddForm = () => {
    resetForm();
    setShowForm(true);
  };

  const openEditForm = (frame) => {
    setName(frame.name);
    setCoins(frame.coins);
    setIsActive(!!frame.is_active);
    setImageFile(null);
    setEditingId(frame.id);
    setShowForm(true);
  };

  const handleSubmit = async () => {
    if (!name || !coins) {
      toast.error("Please fill name and coins");
      return;
    }
    if (!editingId && !imageFile) {
      toast.error("Please select a frame image");
      return;
    }

    setSaving(true);
    try {
      const formData = new FormData();
      formData.append("name", name);
      formData.append("coins", coins);
      formData.append("is_active", isActive ? 1 : 0);
      if (imageFile) formData.append("image", imageFile);
      if (editingId) formData.append("id", editingId);

      const apiUrl = process.env.REACT_APP_API_URL;
      const endpoint = editingId ? "edit_frame" : "add_frame";

      const res = await axios.post(`${apiUrl}/${endpoint}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });

      toast.success(res?.data?.message || "Saved successfully!");
      setShowForm(false);
      resetForm();
      fetchFrames();
    } catch (err) {
      toast.error(err?.response?.data?.message || "Something went wrong");
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this frame?")) return;
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const res = await axios.post(`${apiUrl}/delete_frame`, { id }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success(res?.data?.message || "Deleted successfully!");
      fetchFrames();
    } catch (err) {
      toast.error("Failed to delete");
    }
  };

  return (
    <div className={`dark:bg-primary ${isSidebarOpen ? "xl:pl-20" : "xl:pl-72"}`}>
      <Searchbar />
      <div className="px-4 pb-10 xl:px-6">

        <div className="flex items-center justify-between py-3">
          <h2 className="text-[#000000] font-semibold font-poppins text-xl pt-3 dark:text-darkText">
            Frames
          </h2>
          <button
            style={{ backgroundColor: '#593A99' }}
            className="px-6 py-2.5 text-sm font-medium text-white rounded-lg font-poppins"
            onClick={openAddForm}
          >
            + Add Frame
          </button>
        </div>

        {/* Add/Edit Form */}
        {showForm && (
          <div className="border border-opacity-gradient dark:border-[#1F1F1F] bg-[#FFFFFF] dark:bg-primary rounded-lg p-6 mb-6">
            <h3 className="text-base font-semibold font-poppins text-header pb-4">
              {editingId ? "Edit Frame" : "Add New Frame"}
            </h3>
            <div className="grid gap-4 md:grid-cols-3">
              <div>
                <label className="text-sm font-semibold font-poppins dark:text-darkText">Name</label>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="border border-opacity-gradient dark:bg-transparent dark:text-darkText dark:border-borderColor rounded-lg w-full py-3 my-1 px-4 focus:outline-none focus:ring-1 focus:ring-header"
                  placeholder="e.g. Gold Frame"
                />
              </div>
              <div>
                <label className="text-sm font-semibold font-poppins dark:text-darkText">Coins</label>
                <input
                  type="number"
                  value={coins}
                  onChange={(e) => setCoins(e.target.value)}
                  className="border border-opacity-gradient dark:bg-transparent dark:text-darkText dark:border-borderColor rounded-lg w-full py-3 my-1 px-4 focus:outline-none focus:ring-1 focus:ring-header"
                  placeholder="e.g. 150"
                />
              </div>
              <div>
                <label className="text-sm font-semibold font-poppins dark:text-darkText">
                  Frame Image {editingId && "(leave empty to keep current)"}
                </label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => setImageFile(e.target.files[0])}
                  className="w-full py-2 my-1 text-sm font-poppins dark:text-darkText"
                />
              </div>
              <div className="flex items-center gap-2">
                <input
                  type="checkbox"
                  checked={isActive}
                  onChange={(e) => setIsActive(e.target.checked)}
                  id="frame_is_active"
                />
                <label htmlFor="frame_is_active" className="text-sm font-poppins dark:text-darkText">Active</label>
              </div>
            </div>

            <div className="flex gap-3 pt-5">
              <button
                onClick={handleSubmit}
                disabled={saving}
                style={{ backgroundColor: '#593A99' }}
                className="px-8 py-2.5 text-sm font-medium text-white rounded-lg font-poppins"
              >
                {saving ? "Saving..." : "Save"}
              </button>
              <button
                onClick={() => { setShowForm(false); resetForm(); }}
                className="px-8 py-2.5 text-sm font-medium border border-header rounded-lg font-poppins dark:text-darkText"
              >
                Cancel
              </button>
            </div>
          </div>
        )}

        {/* List */}
        {loading ? (
          <p className="font-poppins dark:text-darkText">Loading...</p>
        ) : frames.length > 0 ? (
          <div className="grid gap-4 md:grid-cols-3 lg:grid-cols-4">
            {frames.map((frame) => (
              <div key={frame.id} className="overflow-hidden bg-white border border-gray-200 dark:bg-primary dark:border-[#1F1F1F] rounded-xl">
                <div className="flex items-center justify-center h-32 bg-[#00000005] dark:bg-[#1F1F1F]">
                  <img src={frame.image_url} alt={frame.name} className="object-contain h-24" />
                </div>
                <div className="p-4">
                  <p className="font-poppins text-sm font-semibold dark:text-darkText">{frame.name}</p>
                  <p className="font-poppins text-xs text-[#E89A00] font-semibold pt-1">🪙 {frame.coins}</p>
                  <span className={`inline-block mt-2 px-2 py-0.5 text-xs rounded-full font-poppins ${
                    frame.is_active
                      ? "text-[#0D9947] bg-[#0D9947] bg-opacity-15"
                      : "text-[#999999] bg-[#999999] bg-opacity-15"
                  }`}>
                    {frame.is_active ? "Active" : "Inactive"}
                  </span>
                  <div className="flex gap-2 pt-3">
                    <button
                      onClick={() => openEditForm(frame)}
                      className="flex-1 px-3 py-1.5 text-xs font-poppins text-[#593A99] border border-[#593A99] rounded-lg"
                    >
                      Edit
                    </button>
                    <button
                      onClick={() => handleDelete(frame.id)}
                      className="flex-1 px-3 py-1.5 text-xs font-poppins text-[#D92D20] border border-[#D92D20] rounded-lg"
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center py-32">
            <img src={NoData} alt="no data" className="w-96" />
            <h2 className="text-sm font-semibold font-poppins text-[#000000]">
              Don't have any data to show
            </h2>
          </div>
        )}
      </div>
    </div>
  );
}

export default FrameList;